/*
 * GoalDetails.jsx 02.08.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import format from 'date-fns/format';
import History from './History';

import isBefore from 'date-fns/is_before';

import {RedDot, YellowRing} from '../core/Notification';
import GoalResultContainer from '../../containers/detail/GoalResultContainer';
import GoalStepsContainer from '../../containers/detail/GoalStepsContainer';
import {checkNearDeadline} from '../../utils';


const dateFormat = 'DD.MM.YYYY';

const styles = theme => ({

    goalFrame: {
        overflowY: 'auto',
        height: '79vh',
        paddingBottom: 40
    },

    goalDetails: {
        width: 'auto',
        margin: '0.8rem 24px 0.8rem 24px',
        borderRadius: 4,

        backgroundColor: '#ffffff',
        color: '#3F3F4E'
    },

    goal: {
        display: 'grid',
        gridTemplateColumns: 'auto 250px 200px',
        gridTemplateAreas: '"goalText goalText history" "goalStart . history" "goalEnd . history"'
    },

    goalText: {
        gridArea: 'goalText',
        wordWrap: 'break-word',
        padding: '1.5rem 5rem 1rem 2rem',
        minHeight: 247,
        fontWeight: '500',
        overflowY: 'auto',
        color: theme.palette.text.secondary
    },

    goalStart: {
        gridArea: 'goalStart',
        display: 'grid',
        gridTemplateAreas: '"icon label value"',
        gridTemplateColumns: '7% 45% 45%',
        padding: '0 1rem',
        textAlign: 'left',
        width: '13vw',
        color: theme.palette.text.secondary
    },

    goalEnd: {
        gridArea: 'goalEnd',
        display: 'grid',
        gridTemplateAreas: '"icon label value"',
        gridTemplateColumns: '7% 45% 45%',
        padding: '0 1rem 1.5rem 1rem',
        width: '13vw',
        textAlign: 'left',
        color: theme.palette.text.secondary
    },

    noGoalSelected: {
        marginTop: '50px',
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    goalDateIcon: {
        gridArea: 'icon'
    },
    goalDateLabel: {
        gridArea: 'label'
    },
    goalDateValue: {
        gridArea: 'value'
    }
});

class GoalDetailsFrame extends React.Component {

    render() {
        const {classes, goal} = this.props;

        if (!goal) {
            return <Typography className={classes.noGoalSelected}>Bitte lege ein Ziel in stepnova an.</Typography>;
        }

        return (
            <div className={classes.goalFrame}>
                <Paper className={classes.goalDetails} elevation={2}>

                    <div className={classes.goal}>
                        <Typography className={classes.goalText}>{goal.zielvereinbarung}</Typography>

                        <Typography className={classes.goalStart} noWrap >
                            <span className={classes.goalDateLabel}>Start:</span>
                            <span className={classes.goalDateValue}>{format(goal.anfang, dateFormat)}</span>
                        </Typography>

                        <Typography className={classes.goalEnd} noWrap>
                            <span className={classes.goalDateIcon}>{
                                !goal.zielerreicht && isBefore(goal.ende, new Date()) ? <RedDot /> : !goal.zielerreicht && checkNearDeadline(goal) && <YellowRing />
                            }</span>
                            <span className={classes.goalDateLabel}>{goal.zielerreicht ? 'Erreicht' : 'Frist'}:</span>
                            <span className={classes.goalDateValue}>{format(goal.zielerreicht ? goal.zielerreichtAm : goal.ende, dateFormat)}</span>
                        </Typography>

                        <History history={goal} />
                    </div>
                </Paper>

                <GoalStepsContainer />
                <GoalResultContainer />
            </div>
        );
    }
}


export default withStyles(styles)(GoalDetailsFrame);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/detail/GoalDetailsFrame.jsx